import api from '@/lib/axios';

export interface User {
    _id: string; // The backend uses _id
    id?: string; // Sometimes frontend components map it to id
    name: string;
    email: string;
    role: 'super_admin' | 'admin' | 'editor';
    status: 'Aktif' | 'Pasif';
    lastLogin?: string; // This might be computed or updated on login
    createdBy?: {
        _id: string;
        name: string;
        email: string;
        role: string;
    } | string | null;
    createdAt: string;
    updatedAt: string;
}

export type CreateUserData = Omit<User, '_id' | 'id' | 'createdAt' | 'updatedAt'> & { password?: string };
export type UpdateUserData = Partial<CreateUserData>;

export const userService = {
    // Get all users
    getUsers: async () => {
        const response = await api.get<User[]>('/users');
        // Map _id to id for frontend components
        return response.data.map((u: User) => ({ ...u, id: u._id }));
    },

    // Create a new user
    createUser: async (data: CreateUserData) => {
        const response = await api.post<User>('/users', data);
        return { ...response.data, id: response.data._id };
    },

    // Update an existing user
    updateUser: async (id: string, data: UpdateUserData) => {
        const response = await api.put<User>(`/users/${id}`, data);
        return { ...response.data, id: response.data._id };
    },

    // Delete a user
    deleteUser: async (id: string) => {
        const response = await api.delete<{ message: string }>(`/users/${id}`);
        return response.data;
    }
};
